/**
 * Phonebay product carousel tabs — switch panels + staggered card animation
 */
(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animatePanel(panel) {
    if (!panel || prefersReducedMotion) return;

    panel.classList.remove('pb-tab-panel--enter');
    const cards = panel.querySelectorAll('.pb-card');
    cards.forEach((card) => {
      card.classList.remove('pb-tab-card--animate');
      card.style.animationDelay = '';
    });

    void panel.offsetWidth;

    panel.classList.add('pb-tab-panel--enter');
    cards.forEach((card, index) => {
      card.style.animationDelay = `${Math.min(index * 0.06, 0.42)}s`;
      card.classList.add('pb-tab-card--animate');
    });
  }

  function initSection(sectionEl) {
    const tabs = sectionEl.querySelectorAll('[data-pb-tab]');
    const panels = sectionEl.querySelectorAll('[data-pb-tab-panel]');
    if (!tabs.length || !panels.length) return;

    let activeId = null;

    function showPanel(panelId, shouldAnimate) {
      panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.hidden = !isActive;
        panel.style.display = isActive ? 'grid' : 'none';
        if (!isActive) {
          panel.classList.remove('pb-tab-panel--enter');
          panel.querySelectorAll('.pb-card').forEach((card) => {
            card.classList.remove('pb-tab-card--animate');
            card.style.animationDelay = '';
          });
        }
      });

      tabs.forEach((tab) => {
        const active = tab.dataset.pbTabTarget === panelId;
        tab.classList.toggle('pb-tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      const activePanel = document.getElementById(panelId);
      if (shouldAnimate && activePanel) {
        animatePanel(activePanel);
      }

      activeId = panelId;
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.pbTabTarget;
        if (target && target !== activeId) {
          showPanel(target, true);
        }
      });
    });

    const first = tabs[0]?.dataset.pbTabTarget;
    if (first) showPanel(first, false);
  }

  function init() {
    document.querySelectorAll('[data-pb-tabs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-pb-tabs]');
    if (root) initSection(root);
  });
})();
